import PropTypes from "prop-types";
import { X } from "@phosphor-icons/react";
import { BackButton } from "../../../pages/MatterDetails/MatterDetailsStyled";
import {
  StyledDialog,
  StyledDialogTitle,
  StyledDialogContent,
  StyledDialogActions,
  HeadingText,
  ContentText,
  PrimaryButton,
  SecondaryButton,
  HeadingWrapper,
} from "./CustomModalStyled.js";
import { TickFrame } from "../Modals/MessageModal/MessageModalStyled.js";

const CustomModal = ({
  open,
  onClose,
  heading,
  content,
  btnTxtPrimary,
  btnTxtSecondary,
  onPrimaryClick,
  onSecondaryClick,
  disabled,
  variant = "default",
  icon,
}) => {
  const variantStyles = {
    delete: {
      color: "#FFFFFF",
      bgColor: "#B31514",
    },
    warning: {
      color: "#000000",
      bgColor: "#FFA500",
    },
    // Add more variants here
  };

  const currentStyle = variantStyles[variant] || variantStyles.delete;

  return (
    <StyledDialog open={open} onClose={onClose} fullWidth maxWidth="xs">
      <StyledDialogTitle>
        <HeadingWrapper>
          {icon && <TickFrame>{icon}</TickFrame>}
          <HeadingText>{heading}</HeadingText>
        </HeadingWrapper>

        <BackButton>
          <X size={20} onClick={onClose} />
        </BackButton>
      </StyledDialogTitle>

      <StyledDialogContent>
        <ContentText>{content}</ContentText>
      </StyledDialogContent>

      <StyledDialogActions>
        <SecondaryButton onClick={onSecondaryClick}>
          {btnTxtSecondary}
        </SecondaryButton>
        <PrimaryButton
          onClick={onPrimaryClick}
          disabled={disabled}
          {...currentStyle}
        >
          {btnTxtPrimary}
        </PrimaryButton>
      </StyledDialogActions>
    </StyledDialog>
  );
};

CustomModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  content: PropTypes.string.isRequired,
  btnTxtPrimary: PropTypes.string.isRequired,
  btnTxtSecondary: PropTypes.string.isRequired,
  onPrimaryClick: PropTypes.func.isRequired,
  onSecondaryClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  variant: PropTypes.string,
  icon: PropTypes.node,
};

export default CustomModal;
